import { Injectable } from '@angular/core';
import {Resolve, Router, ActivatedRouteSnapshot } from '@angular/router';
import { UserService } from './user.service';

@Injectable()
export class UserConfigResolve  implements Resolve<any> {
    constructor(private _userService: UserService, private _router: Router) { }
    
    resolve(route: ActivatedRouteSnapshot): Promise<boolean> | boolean {
        return new Promise((resolve,reject)=>{
            this._userService.loadUserInfo().then(
            (result) => {
                  resolve(this._userService.getConfig())            
            },
            (err)=>{
              
              this._router.navigate(['/auth/login']);
            }
          )
        });
    }
}